import React, {Component, useState} from "react";
import axios from "axios";
import { Box } from "react-bulma-components";
import { Form } from "react-bulma-components";

import { Button } from "react-bulma-components";
import { Pagination } from "react-bulma-components";
import { Table } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import qs from "qs";
import {getQueryString} from "../../utils";
import {useContactsData} from "../../hooks/useContactsData";
import Spinner from "react-spinner-material";
import {useSelector} from "react-redux";
import {getContactsData} from "../../state/selectors";
import SearchBar from "../Utils/SearchBar";
import useSelect from "../../hooks/useSelect";
import {getPhoneNumber} from "../../utils";

function Contacts({history, endpoint, location}) {
  const [page, setPage] = useState(1);

  const [searchText, setSearchText] = useState();
  const [currentSearch, setCurrentSearch] = useState();
  const [searchFresh, setSearchFresh] = useState(1);

  const types = {
    CC: "Customer",
    SP: "Supplier"
  };

  const [deactive, deactiveInput] = useSelect({
    label: "Show Deactivated",
    initialValue: "NO",
    options: [
        {name:"No", value: "NO"},
        {name:"Yes", value:"YES"}
    ]
  });


  let view;
  let viewName = "Contacts";
  let newContactUrl = "/editcontact"

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  let params = {page};

  const [typeView, typeViewInput] = useSelect({
    label: "Type",
    initialValue: queryParams.type ? queryParams.type : "ALL",
    options: [
      {name: "ALL", value: "ALL"},
      {name: "Customer", value: "CC"},
      {name: "Supplier", value: "SP"}
    ]
  });

  const [onlyView, onlyViewInput] = useSelect({
    label: "Show Only",
    initialValue: "NONE",
    options: [
      {name: "", value: "NONE"},
      {name: "Partial Contacts", value: "pc"},
      {name: "Missing Account Forms", value: "maf"}
    ]
  });

  // if (queryParams.type) {
  //   view = queryParams.type;
  //   params.contact_type = view;
  //   newContactUrl += "?type=" + view;
  //   viewName = types[view] + "s";
  // }
  if(typeView !== "ALL"){
    view = typeView;
    params.contact_type = typeView;
    newContactUrl += "?type=" + view;
    viewName = types[view] + "s";
  }
  if(onlyView){
    params.only_view=onlyView
  }
  if (currentSearch) {
    params.search = currentSearch;
  }
  if (deactive === "YES"){
    params.show_deactive="true"
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  const complete = useContactsData(params);
  const data = useSelector(getContactsData);

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh + 1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  if (!complete) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  document.title = viewName;

  return (
    <div>
      <Box>
        <Columns>
          <Columns.Column>
            <Form.Label>Search</Form.Label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Columns.Column>
          {deactiveInput}
          {onlyViewInput}
          {typeViewInput}
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={() => history.push(newContactUrl)}
                  color="success"
                  className="is-pulled-right"
                >
                  New {view ? types[view] : "Contact" } +
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
      </Box>
      <Box>
        <h1 className="title">{viewName}</h1>
        <Table striped={false} className="is-hoverable" size={"fullwidth"}>
          <thead>
          <tr>
            <th>ID</th>
            <th>Type</th>
            <th>Display Name</th>
            <th>Contact Number</th>
            <th>Email</th>
            <th>Address</th>
          </tr>
          </thead>
          <tbody>{data.results.map((value, index) => (
            <tr
              className="clickable"
              onClick={() => window.open(`/editcontact/${value.id}`, "_self")}
              key={value.id ?? index}
            >
              <td>{value.id}</td>
              <td>{types[value.contact_type]} </td>
              <td>{value.display_name}</td>
              <td>{getPhoneNumber(value)}</td>
              <td>{value.email}</td>
              <td onClick={(e) => e.stopPropagation()}>
          <pre>
            {`${value.address_line1}\n ${value.town} \n ${value.postcode}`}{" "}
          </pre>
              </td>
            </tr>
          ))}</tbody>
        </Table>
        <Pagination
          showFirstLast={true}
          onChange={setPage}
          current={page}
          total={Math.ceil(data.count / 25)}
        />
      </Box>
    </div>
  );
}

export default Contacts;
